<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-briefcase" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">{{ organization.name }}</h4>
              <small style="opacity: .8;">Establishment overview</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Actions Card -->
        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <button class="btn btn-submit" @click="acceptorganization(1)" v-if="organization.status == false">
              <i class="fe fe-check mr-1"></i> Approve
            </button>
            <button class="btn btn-outline-danger" @click="acceptorganization(0)" v-if="organization.status == true">
              <i class="fe fe-x mr-1"></i> Disapprove
            </button>
            <router-link :to="{ path: '/add-employee-state' }">
              <button class="btn btn-outline-secondary">
                <i class="fe fe-users mr-1"></i> Manage Personnel
              </button>
            </router-link>
            <button class="btn btn-outline-secondary" data-toggle="modal" data-target="#slideRightModalAll">
              <i class="fe fe-credit-card mr-1"></i> Add Payment
            </button>
            <button class="btn btn-outline-secondary" @click="triggerCsvImport">
              <i class="fe fe-upload mr-1"></i> Import Enrollees
            </button>
            <button class="btn btn-outline-secondary" @click="downloadSampleCsv">
              <i class="fe fe-download mr-1"></i> Download Sample Sheet
            </button>
            <input ref="csvInput" type="file" accept=".csv,text/csv" class="d-none" @change="onCsvFileSelected" />
          </div>
        </div>

        <!-- Stat Tiles -->
        <div class="row mb-2">
          <div class="col-lg-4 col-md-6 mb-4">
            <router-link :to="{ path: '/view-clients-organization' }" class="text-decoration-none">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                  <div class="avatar avatar-md flex-shrink-0">
                    <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                      <i class="mdi mdi-account-group"></i>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Enrollees</p>
                    <h4 class="mb-0 font-weight-bold text-dark">{{ dashboarddata.enrollees | numeral("0,0") }}</h4>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-info rounded-circle text-info">
                    <i class="mdi mdi-folder-multiple"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Encounters</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ dashboarddata.encounters | numeral("0,0") }}</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                  <div class="avatar avatar-md flex-shrink-0">
                    <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                      <i class="fe fe-credit-card"></i>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Transactions</p>
                    <h4 class="mb-0 font-weight-bold text-dark">{{ transactions.total | numeral("0,0") }}</h4>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                    <i class="mdi mdi-folder-multiple"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Utilization Rate</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ dashboarddata.encounter_rate_total | numeral("0,0.00") }}%</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-success rounded-circle text-success">
                    <i class="mdi mdi-folder-multiple"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Utilization Rate (Current Month)</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ dashboarddata.encounter_rate_current_month | numeral("0,0.00") }}%</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                    <i class="mdi mdi-bank-transfer-out"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Referral Rate (Current Month)</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ dashboarddata.referral_rate_current_month | numeral("0,0.00") }}%</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Enrollees / Transactions Tables -->
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="card shadow table-card h-100">
              <div class="d-flex align-items-center px-4 pt-4 pb-3">
                <i class="fe fe-users text-primary mr-2"></i>
                <h6 class="mb-0 font-weight-bold">Enrollees</h6>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Name</th>
                      <th class="table-th">ID</th>
                      <th class="table-th">Contact</th>
                      <th class="table-th">Plan</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="enrollee in organizationclients.data" v-bind:key="enrollee.id">
                      <td>
                        <router-link :to="{ path: '/client/' + enrollee.id }">{{ enrollee.full_name }}</router-link>
                      </td>
                      <td><span class="code-chip">{{ enrollee.id_card_number }}</span></td>
                      <td>{{ enrollee.phone_number }}</td>
                      <td>{{ enrollee.sector }}</td>
                      <td>
                        <router-link :to="{ path: '/client/' + enrollee.id }">
                          <button type="button" class="btn btn-sm btn-outline-secondary"><i class="fe fe-eye"></i></button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="card shadow table-card h-100">
              <div class="d-flex align-items-center px-4 pt-4 pb-3">
                <i class="fe fe-credit-card text-primary mr-2"></i>
                <h6 class="mb-0 font-weight-bold">Transactions</h6>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Amount</th>
                      <th class="table-th">Enrollees</th>
                      <th class="table-th">Date</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="trx in transactions.data" v-bind:key="trx.id">
                      <td><i class="mdi mdi-currency-ngn"></i> {{ trx.amount | numeral("0,0") }}</td>
                      <td><span v-if="trx.users.length > 0">{{ trx.users.length }}</span></td>
                      <td>{{ trx.created_at | moment("dddd, MMMM Do YYYY") }}</td>
                      <td>
                        <a :href="`/payment/transaction/${trx.id}`" class="btn btn-sm btn-outline-secondary">
                          <i class="fe fe-eye"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal: Add Payment -->
        <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog"
          aria-labelledby="slideRightModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content" id="printDiv" ref="printNow">
              <div class="modal-header">
                <p class="modal-title" id="slideRightModalLabel">
                  <span class="h5">Payment Details</span>
                </p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <form @submit.prevent="addTransaction">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Select Enrollees</label>
                      <select class="form-control" @change="getOrganizationClients(organization)" v-model="transaction.enabled_user">
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option :value="false">Inactive</option>
                        <option value="false">Selected</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Select Plan <span class="text-danger">*</span></label>
                      <select class="form-control" required v-model="transaction.sector">
                        <option :value="plan.cost" v-for="plan in plans" :key="plan.id">
                          {{ plan.title }} - {{ plan.cost | numeral(0, 0) }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group col-md-12">
                    <label class="info-label d-block mb-1">Qty <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" required disabled
                      :value="organizationclients.meta.total" placeholder="Amount" />
                    <p class="text-sm">total enrollees under the establishment</p>
                  </div>

                  <div class="form-group col-md-12">
                    <label class="info-label d-block mb-1">Amount <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" required disabled
                      :value="transaction.sector * organizationclients.meta.total" placeholder="Amount" />
                  </div>

                  <div class="form-group col-md-12">
                    <label class="info-label d-block mb-1">Date of Payment <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" required :value="transaction.date" placeholder="Date" />
                  </div>

                  <div class="form-group col-md-12">
                    <label class="info-label d-block mb-1">Description</label>
                    <textarea name="name" rows="3" cols="80" class="form-control" v-model="transaction.description"></textarea>
                    <button type="submit" class="btn btn-submit m-2 btn-block">Submit</button>
                  </div>
                </form>
              </div>

              <div class="modal-footer"></div>
            </div>
          </div>
        </div>
        <!-- End of Modal -->

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import {
  buildSampleCsvText,
  parseCsvRows,
  mapCsvRowToPayload,
} from "@/service/enrollee_csv_import";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      types: ["online", "offline"],
      organization: "",
      transaction: {
        amount: 0,
        type: "offline",
        description: "",
        date: "",
      },
      transactions: [],
      organizationclients: {
        meta: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          from: 0,
          to: 0,
        },
        data: [],
      },
      plans: "",
      dashboarddata: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/transactions`, {
        params: {
          agency_id: 407465,
          ministry_model_id: this.$route.params.id,
        },
      })
      .then((response) => {
        this.transactions = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getOrganization() {
      this.axios
        .get(`/api/v1/auth/ministry/${this.$route.params.id}`)
        .then((response) => {
          this.organization = response.data.data;
          this.getOrganizationClients(this.organization);
          this.dashboardData(this.organization);
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    dashboardData(org) {
      this.axios
        .get(`/api/v1/auth/ministry/stat/407465/${org.id}`)
        .then((response) => {
          this.dashboarddata = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getOrganizationClients(org) {
      this.isLoading = true;

      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getUsersfilterparams`, {
          params: {
            page: 1,
            agency_id: 407465,
            perPage: 1000,
            place_of_work: org.name,
            enabled_user: this.transaction.enabled_user,
          },
        })
        .then((response) => {
          this.organizationclients = response.data;
          this.isLoading = false;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    acceptorganization(status) {
      if (confirm("Are You Sure You Want to Update this MDA?")) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/approveDisapproveorganizationByAgency", {
            agency_id: 407465,
            organization_id: this.$route.params.id,
            status: status,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("MDA Updated!", {
              position: "top-right",
            });
            this.isLoading = false;
            this.getOrganization();
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },

    triggerCsvImport() {
      if (this.$refs.csvInput) {
        this.$refs.csvInput.click();
      }
    },
    downloadSampleCsv() {
      const csvText = buildSampleCsvText();
      const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "enrollee_import_sample.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    onCsvFileSelected(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      const isCsv = file.type.includes("csv") || file.name.toLowerCase().endsWith(".csv");
      if (!isCsv) {
        this.$toasted.error("Please select a CSV file", {
          position: "top-center",
          duration: 3000,
        });
        event.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = async (loadEvent) => {
        const csvText = loadEvent.target && loadEvent.target.result ? String(loadEvent.target.result) : "";
        await this.importUsersFromCsv(csvText);
        event.target.value = "";
      };
      reader.onerror = () => {
        this.$toasted.error("Unable to read CSV file", {
          position: "top-center",
          duration: 3000,
        });
        event.target.value = "";
      };
      reader.readAsText(file);
    },
    async importUsersFromCsv(csvText) {
      if (!this.organization || !this.organization.name) {
        this.$toasted.error("Organization not loaded yet", {
          position: "top-center",
          duration: 3000,
        });
        return;
      }

      const rows = parseCsvRows(csvText);
      if (!rows.length) {
        this.$toasted.error("CSV is empty", {
          position: "top-center",
          duration: 3000,
        });
        return;
      }

      this.isLoading = true;
      let successCount = 0;
      let failureCount = 0;

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const payload = mapCsvRowToPayload(row, {
          agencyId: 407465,
          enrolledBy: this.user ? this.user.id : 0,
        });

        if (!payload) {
          failureCount++;
          continue;
        }

        try {
          await this.axios.post("/api/v1/auth/registerProvider", payload);
          successCount++;
        } catch (error) {
          console.error(error);
          failureCount++;
        }
      }

      this.isLoading = false;

      if (successCount > 0) {
        this.$toasted.success(`Imported ${successCount} enrollee(s)`, {
          position: "top-center",
          duration: 4000,
        });
        this.getOrganizationClients(this.organization);
        this.dashboardData(this.organization);
      }

      if (failureCount > 0) {
        this.$toasted.error(`${failureCount} row(s) failed to import`, {
          position: "top-center",
          duration: 4000,
        });
      }
    },

    addTransaction() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/transactions`, {
          agency_id: 407465,
          amount: this.transaction.sector * this.organizationclients.meta.total,
          type: this.transaction.type,
          date: this.transaction.date,
          ministry_model_id: this.$route.params.id,
          description: this.transaction.description,
          transaction_ref: Math.floor(Math.random() * 10 ** 20).toString().padStart(20, "0"),
          status: "approved",
          users: this.dashboarddata.ids,
        })
        .then((response) => {
          console.log(response);
          this.$toasted.success("Submitted Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },

    fetchPlans() {
      this.axios
        .get(`/api/v1/auth/plans`, {
          params: {
            agency_id: 407465,
            perPage: 1000,
          },
        })
        .then((response) => {
          this.plans = response.data.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getOrganization();
    this.fetchPlans();
  },
};
</script>
